
import axiosInstance from "../../confiq/axiosInstance";
import config, { userToken } from "../../confiq/confiq";

const baseURL = config.apiUrl;
const headers = config.headers;

export const getProduct = async (slug) => {
    try {
        const endpoint = `/api/products/${slug || null}`;
        const response = await axiosInstance.get(`${endpoint}`, {
            headers: headers,
        });
        return response?.data?.data;
    } catch (error) {
        console.error("Error fetching Products:", error);
        throw error;
    }
};


export const getThreadsMessage = async (threadId, id) => {
    try {
      const endpoint = `/api/product/${id}/chatgpt/threads/${threadId}`;    
      const response = await axiosInstance.get(`${endpoint}`, {
        headers: headers,
      });
      return response?.data;
    } catch (error) {
      console.error("Error fetching Threads:", error);
      throw error;
    }
  };

  export const getThreadsForProduct = async (id) => {
    try {
      const endpoint =`/api/product/${id}/chatgpt/threads`;
      const response = await axiosInstance.get(`${endpoint}`, {
        headers: headers,
      });
      return response?.data;
    } catch (error) {
      console.error("Error fetching Threads:", error);
      throw error;
    }
  };


  export const createRun = async ( productId, threadId, prompt) => {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `${baseUrl}api/product/${productId}/chatgpt/threads/${threadId}/run`;
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify(prompt),
      });
      return response;
    } catch (error) {
      console.error("Error in createRun:", error.message || error);
      throw new Error("Failed to createRun prompt. Please try again.");
    }
  };
  
  export const createThreadRun = async ( productId, prompt) => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      const endpoint = `${baseUrl}api/product/${productId}/chatgpt/threads`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify(prompt),
      });
      return response;
    } catch (error) {
      console.error("Error creating prompt:", error.response?.data || error.message);
      throw new Error("Failed to create prompt. Please try again.");
    }
  };
  
  export const removeThread = async ( productId, threadId, prompt) => {
    try {
      const endpoint = `/api/product/${productId}/chatgpt/threads/${threadId}/archive`;
  
      const response = await axiosInstance.put(endpoint, prompt, headers);
      return response?.data;
    } catch (error) {
      console.error("Error deleting thread:", error.response?.data || error.message);
      throw new Error("Failed to create prompt. Please try again.");
    }
  };
  
  export const updateRelavancy = async ( productId, threadId, messageId, prompt) => {
    try {
      const endpoint = `/api/product/${productId}/chatgpt/threads/${threadId}/${messageId}/relavance`;
  
      const response = await axiosInstance.put(endpoint, prompt, headers);
      return response?.data;
    } catch (error) {
      console.error("Error updateRelavancy message:", error.response?.data || error.message);
      throw new Error("Failed to updateRelavancy. Please try again.");
    }
  };

